import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ISingleIdParams } from '../../../spacesPlatform/utils/actionParams';
import { IPublishedConnectionTableActions } from '../types/IPublishedConnectionTableActions';

export class GetPublishedConnectionTableActionsRequest extends Request<ISingleIdParams, IPublishedConnectionTableActions> {
  constructor(id: string) {
    super('getPublishedConnectionTableActions', { id: id });
  }
}
